export default __webpack_public_path__ + "img/image.355e4c3c.svg";